<template>
  <div class="login-view">
    <img class="site-logo" src="@/assets/unsung-logo-color.png" />
    <h3>Teacher Login</h3>
    <div :class="(loginSuccess === false || charCheck === false) ? 'error' : ''">
      <input id="email-input" v-model="input.username" placeholder="Email" type="email" />
      <br />
      <div class="password-container">
        <input id="access-code-input" v-model="input.accessCode" placeholder="Access Code" type="password" />
      </div>
      <p v-if="loginSuccess === false">Invalid Email or Access Code</p>
      <p v-if="charCheck === false">Access Code Must Be 10 Characters Long</p>
    </div>
    <div>
      <br />
      <button type="button" @click="login">Login</button>
    </div>
    <p>Interested in getting Unsung for your classroom? <a href="https://www.verizon.com/learning" target="_blank">Learn
        more</a>.</p>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {
      charCheck: true,
      input: {
        username: "",
        accessCode: "",
      },
    };
  },
  computed: {
    loginSuccess: function () {
      return this.$store.state.loginSuccess;
    },
  },
  methods: {
    login: function () {
      if (
        this.input.accessCode.length == 10 &&
        this.input.accessCode.match(/^[0-9a-z]+$/i)
      ) {
        // console.log("trying to login")
        this.$store.commit("SEND_MESSAGE", {
          data: {
            email: this.input.username,
            accessCode: this.input.accessCode,
          },
          opCode: this.$store.state.opCodes.VerizonTeacherClientLogin,
        });
        this.$store.commit("SET_USER_TYPE", 'Teacher');
      } else {
        this.charCheck = false;
      }
    },
    send: function () {
      // console.log("send");
      this.$emit("clicked", {
        email: this.email,
        password: this.password,
      });
    },
    disconnect: function () {
      this.conn.disconnect();
    },
  },
};
</script>

<style lang="scss">
/* ../assets/scss/_login.scss */
</style>